import style from './SignUpNotification.module.css';
import { useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import { RxCross1 } from 'react-icons/rx';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { selectUserType } from '../../../redux/auth/selectors';
import { selectIsMuted } from '../../../redux/settings/selectors';

const SignUpNotification = ({ id, user }) => {
  const navigate = useNavigate();
  const userType = useSelector(selectUserType);
  const isMutedNotification = useSelector(selectIsMuted);
  const userAvatar = user?.videoAvatar || user?.avatar;
  const hasVideo = userAvatar?.includes('videos');

  const handleCloseClick = () => {
    toast.dismiss(id);
  };

  const handleRedirect = () => {
    if (userType === 'paidUser') {
      navigate(`/man-user/user-profile/${user._id}`);
    } else if (userType === 'freeUser') {
      navigate(`/free-user/user-profile/${user._id}`);
    }
  };

  useEffect(() => {
    if (isMutedNotification) {
      handleCloseClick();
    }
  }, [isMutedNotification]);

  if (isMutedNotification) {
    return null;
  }

  return (
    <div className={style.notification}>
      <div className={style.imgContainer} onClick={handleRedirect}>
        {!hasVideo ? (
          <img
            loading="lazy"
            decoding="async"
            src={user?.avatar}
            alt={`${user?.name}_from_${user?.country}`}
          />
        ) : (
          <video
            src={user?.videoAvatar}
            autoPlay
            loop
            muted
            playsInline
            poster={user?.avatar}
          />
        )}
      </div>
      <div className={style.recipientContainer} onClick={handleRedirect}>
        <h4>{user?.name} Signs in now</h4>
        <p>{user.name} is Online now</p>
      </div>
      <div className={style.close} onClick={handleCloseClick}>
        <RxCross1 />
      </div>
    </div>
  );
};

export default SignUpNotification;
